// test = {
//     "response": {
//         "details": {
//             "tickets_placed": 7,
//             "tickets_won": 1,
//             "total_in": "84.10",
//             "total_out": "312.00"
//         },
//         "tickets": [
//             {
//                 "ticketid": 283651,
//                 "lottery_name": "Grecia Kino 20\/80",
//                 "round_id": 250388,
//                 "round_time": "2019-10-15 14:55:00",
//                 "ticket_time": "2019-10-15 14:51:17",
//                 "money_in": "1.00",
//                 "money_out": "0.00",
//                 "numbers": "10,12,28",
//                 "numbers_won": "12,28",
//                 "game_systems": "3\/3",
//                 "win_array": "0,0,70.3",
//                 "status": "Pierzator",
//                 "status_code": 22,
//                 "currency": "EUR"
//             },
//             {
//                 "ticketid": 283650,
//                 "lottery_name": "Grecia Kino 20\/80",
//                 "round_id": 229149,
//                 "round_time": "2019-06-19 15:00:00",
//                 "ticket_time": "2019-06-19 14:58:37",
//                 "money_in": "1.00",
//                 "money_out": "0.00",
//                 "numbers": "15",
//                 "numbers_won": "",
//                 "game_systems": "1\/1",
//                 "win_array": "3.8",
//                 "status": "Pierzator",
//                 "status_code": 22,
//                 "currency": "EUR"
//             },
//             {
//                 "ticketid": 283649,
//                 "lottery_name": "Grecia Kino 20\/80",
//                 "round_id": 216137,
//                 "round_time": "2019-04-08 10:40:00",
//                 "ticket_time": "2019-04-08 10:35:36",
//                 "money_in": "19.50",
//                 "money_out": "312.00",
//                 "numbers": "60,73",
//                 "numbers_won": "60,73",
//                 "game_systems": "2\/2",
//                 "win_array": "0,312",
//                 "status": "Platit",
//                 "status_code": 21,
//                 "currency": "EUR"
//             },
//             {
//                 "ticketid": 283648,
//                 "lottery_name": "Grecia Kino 20\/80",
//                 "round_id": 216136,
//                 "round_time": "2019-04-08 10:35:00",
//                 "ticket_time": "2019-04-08 10:32:54",
//                 "money_in": "20.80",
//                 "money_out": "0.00",
//                 "numbers": "45,46",
//                 "numbers_won": "",
//                 "game_systems": "2\/2",
//                 "win_array": "0,332.8",
//                 "status": "Pierzator",
//                 "status_code": 22,
//                 "currency": "EUR"
//             },
//             {
//                 "ticketid": 283647,
//                 "lottery_name": "Grecia Kino 20\/80",
//                 "round_id": 216136,
//                 "round_time": "2019-04-08 10:35:00",
//                 "ticket_time": "2019-04-08 10:32:33",
//                 "money_in": "20.60",
//                 "money_out": "0.00",
//                 "numbers": "7,19",
//                 "numbers_won": "",
//                 "game_systems": "2\/2",
//                 "win_array": "0,329.6",
//                 "status": "Pierzator",
//                 "status_code": 22,
//                 "currency": "EUR"
//             },
//             {
//                 "ticketid": 283646,
//                 "lottery_name": "Grecia Kino 20\/80",
//                 "round_id": 216136,
//                 "round_time": "2019-04-08 10:35:00",
//                 "ticket_time": "2019-04-08 10:32:19",
//                 "money_in": "20.20",
//                 "money_out": "0.00",
//                 "numbers": "6,7",
//                 "numbers_won": "",
//                 "game_systems": "2\/2",
//                 "win_array": "0,323.2",
//                 "status": "Pierzator",
//                 "status_code": 22,
//                 "currency": "EUR"
//             },
//             {
//                 "ticketid": 283644,
//                 "lottery_name": "Grecia Kino 20\/80",
//                 "round_id": 214932,
//                 "round_time": "2019-04-01 15:15:00",
//                 "ticket_time": "2019-04-01 15:12:31",
//                 "money_in": "1.00",
//                 "money_out": "0.00",
//                 "numbers": "12,13",
//                 "numbers_won": "",
//                 "game_systems": "2\/2",
//                 "win_array": "0,15.53",
//                 "status": "Pierzator",
//                 "status_code": 22,
//                 "currency": "EUR"
//             }, {
//                 "ticketid": 383651,
//                 "lottery_name": "Grecia Kino 20\/80",
//                 "round_id": 250388,
//                 "round_time": "2019-10-15 14:55:00",
//                 "ticket_time": "2019-10-15 14:51:17",
//                 "money_in": "1.00",
//                 "money_out": "0.00",
//                 "numbers": "10,12,28",
//                 "numbers_won": "12,28",
//                 "game_systems": "3\/3",
//                 "win_array": "0,0,70.3",
//                 "status": "Pierzator",
//                 "status_code": 22,
//                 "currency": "EUR"
//             },
//             {
//                 "ticketid": 483650,
//                 "lottery_name": "Grecia Kino 20\/80",
//                 "round_id": 229149,
//                 "round_time": "2019-06-19 15:00:00",
//                 "ticket_time": "2019-06-19 14:58:37",
//                 "money_in": "1.00",
//                 "money_out": "0.00",
//                 "numbers": "15",
//                 "numbers_won": "",
//                 "game_systems": "1\/1",
//                 "win_array": "3.8",
//                 "status": "Pierzator",
//                 "status_code": 22,
//                 "currency": "EUR"
//             },
//             {
//                 "ticketid": 583649,
//                 "lottery_name": "Grecia Kino 20\/80",
//                 "round_id": 216137,
//                 "round_time": "2019-04-08 10:40:00",
//                 "ticket_time": "2019-04-08 10:35:36",
//                 "money_in": "19.50",
//                 "money_out": "312.00",
//                 "numbers": "60,73",
//                 "numbers_won": "60,73",
//                 "game_systems": "2\/2",
//                 "win_array": "0,312",
//                 "status": "Platit",
//                 "status_code": 21,
//                 "currency": "EUR"
//             },
//             {
//                 "ticketid": 683648,
//                 "lottery_name": "Grecia Kino 20\/80",
//                 "round_id": 216136,
//                 "round_time": "2019-04-08 10:35:00",
//                 "ticket_time": "2019-04-08 10:32:54",
//                 "money_in": "20.80",
//                 "money_out": "0.00",
//                 "numbers": "45,46",
//                 "numbers_won": "",
//                 "game_systems": "2\/2",
//                 "win_array": "0,332.8",
//                 "status": "Pierzator",
//                 "status_code": 22,
//                 "currency": "EUR"
//             },
//             {
//                 "ticketid": 783647,
//                 "lottery_name": "Grecia Kino 20\/80",
//                 "round_id": 216136,
//                 "round_time": "2019-04-08 10:35:00",
//                 "ticket_time": "2019-04-08 10:32:33",
//                 "money_in": "20.60",
//                 "money_out": "0.00",
//                 "numbers": "7,19",
//                 "numbers_won": "",
//                 "game_systems": "2\/2",
//                 "win_array": "0,329.6",
//                 "status": "Pierzator",
//                 "status_code": 22,
//                 "currency": "EUR"
//             },
//             {
//                 "ticketid": 883647,
//                 "lottery_name": "Grecia Kino 20\/80",
//                 "round_id": 216136,
//                 "round_time": "2019-04-08 10:35:00",
//                 "ticket_time": "2019-04-08 10:32:33",
//                 "money_in": "20.60",
//                 "money_out": "0.00",
//                 "numbers": "7,19",
//                 "numbers_won": "",
//                 "game_systems": "2\/2",
//                 "win_array": "0,329.6",
//                 "status": "Pierzator",
//                 "status_code": 22,
//                 "currency": "EUR"
//             },
//             {
//                 "ticketid": 983647,
//                 "lottery_name": "Grecia Kino 20\/80",
//                 "round_id": 216136,
//                 "round_time": "2019-04-08 10:35:00",
//                 "ticket_time": "2019-04-08 10:32:33",
//                 "money_in": "20.60",
//                 "money_out": "0.00",
//                 "numbers": "7,19",
//                 "numbers_won": "",
//                 "game_systems": "2\/2",
//                 "win_array": "0,329.6",
//                 "status": "Pierzator",
//                 "status_code": 22,
//                 "currency": "EUR"
//             },
//             {
//                 "ticketid": 7836475,
//                 "lottery_name": "Grecia Kino 20\/80",
//                 "round_id": 216136,
//                 "round_time": "2019-04-08 10:35:00",
//                 "ticket_time": "2019-04-08 10:32:33",
//                 "money_in": "20.60",
//                 "money_out": "0.00",
//                 "numbers": "7,19",
//                 "numbers_won": "",
//                 "game_systems": "2\/2",
//                 "win_array": "0,329.6",
//                 "status": "Pierzator",
//                 "status_code": 22,
//                 "currency": "EUR"
//             },
//             {
//                 "ticketid": 117836475,
//                 "lottery_name": "Grecia Kino 20\/80",
//                 "round_id": 216136,
//                 "round_time": "2019-04-08 10:35:00",
//                 "ticket_time": "2019-04-08 10:32:33",
//                 "money_in": "20.60",
//                 "money_out": "0.00",
//                 "numbers": "7,19",
//                 "numbers_won": "",
//                 "game_systems": "2\/2",
//                 "win_array": "0,329.6",
//                 "status": "Pierzator",
//                 "status_code": 22,
//                 "currency": "EUR"
//             },
//             {
//                 "ticketid": 227836475,
//                 "lottery_name": "Grecia Kino 20\/80",
//                 "round_id": 216136,
//                 "round_time": "2019-04-08 10:35:00",
//                 "ticket_time": "2019-04-08 10:32:33",
//                 "money_in": "20.60",
//                 "money_out": "0.00",
//                 "numbers": "7,19",
//                 "numbers_won": "",
//                 "game_systems": "2\/2",
//                 "win_array": "0,329.6",
//                 "status": "Pierzator",
//                 "status_code": 22,
//                 "currency": "EUR"
//             },
//             {
//                 "ticketid": 337836475,
//                 "lottery_name": "Grecia Kino 20\/80",
//                 "round_id": 216136,
//                 "round_time": "2019-04-08 10:35:00",
//                 "ticket_time": "2019-04-08 10:32:33",
//                 "money_in": "20.60",
//                 "money_out": "0.00",
//                 "numbers": "7,19",
//                 "numbers_won": "",
//                 "game_systems": "2\/2",
//                 "win_array": "0,329.6",
//                 "status": "Pierzator",
//                 "status_code": 22,
//                 "currency": "EUR"
//             },
//             {
//                 "ticketid": 447836475,
//                 "lottery_name": "Grecia Kino 20\/80",
//                 "round_id": 216136,
//                 "round_time": "2019-04-08 10:35:00",
//                 "ticket_time": "2019-04-08 10:32:33",
//                 "money_in": "20.60",
//                 "money_out": "0.00",
//                 "numbers": "7,19",
//                 "numbers_won": "",
//                 "game_systems": "2\/2",
//                 "win_array": "0,329.6",
//                 "status": "Pierzator",
//                 "status_code": 22,
//                 "currency": "EUR"
//             },
//             {
//                 "ticketid": 457836475,
//                 "lottery_name": "Grecia Kino 20\/80",
//                 "round_id": 216136,
//                 "round_time": "2019-04-08 10:35:00",
//                 "ticket_time": "2019-04-08 10:32:33",
//                 "money_in": "20.60",
//                 "money_out": "0.00",
//                 "numbers": "7,19",
//                 "numbers_won": "",
//                 "game_systems": "2\/2",
//                 "win_array": "0,329.6",
//                 "status": "Pierzator",
//                 "status_code": 22,
//                 "currency": "EUR"
//             },
//             {
//                 "ticketid": 567836475,
//                 "lottery_name": "Grecia Kino 20\/80",
//                 "round_id": 216136,
//                 "round_time": "2019-04-08 10:35:00",
//                 "ticket_time": "2019-04-08 10:32:33",
//                 "money_in": "20.60",
//                 "money_out": "0.00",
//                 "numbers": "7,19",
//                 "numbers_won": "",
//                 "game_systems": "2\/2",
//                 "win_array": "0,329.6",
//                 "status": "Pierzator",
//                 "status_code": 22,
//                 "currency": "EUR"
//             },
//             {
//                 "ticketid": 607836475,
//                 "lottery_name": "Grecia Kino 20\/80",
//                 "round_id": 216136,
//                 "round_time": "2019-04-08 10:35:00",
//                 "ticket_time": "2019-04-08 10:32:33",
//                 "money_in": "20.60",
//                 "money_out": "0.00",
//                 "numbers": "7,19",
//                 "numbers_won": "",
//                 "game_systems": "2\/2",
//                 "win_array": "0,329.6",
//                 "status": "Pierzator",
//                 "status_code": 22,
//                 "currency": "EUR"
//             },
//             {
//                 "ticketid": 667836475,
//                 "lottery_name": "Grecia Kino 20\/80",
//                 "round_id": 216136,
//                 "round_time": "2019-04-08 10:35:00",
//                 "ticket_time": "2019-04-08 10:32:33",
//                 "money_in": "20.60",
//                 "money_out": "0.00",
//                 "numbers": "7,19",
//                 "numbers_won": "",
//                 "game_systems": "2\/2",
//                 "win_array": "0,329.6",
//                 "status": "Pierzator",
//                 "status_code": 22,
//                 "currency": "EUR"
//             },
//             {
//                 "ticketid": 6667836475,
//                 "lottery_name": "Grecia Kino 20\/80",
//                 "round_id": 216136,
//                 "round_time": "2019-04-08 10:35:00",
//                 "ticket_time": "2019-04-08 10:32:33",
//                 "money_in": "20.60",
//                 "money_out": "0.00",
//                 "numbers": "7,19",
//                 "numbers_won": "",
//                 "game_systems": "2\/2",
//                 "win_array": "0,329.6",
//                 "status": "Pierzator",
//                 "status_code": 22,
//                 "currency": "EUR"
//             },
//             {
//                 "ticketid": 117836475,
//                 "lottery_name": "Grecia Kino 20\/80",
//                 "round_id": 216136,
//                 "round_time": "2019-04-08 10:35:00",
//                 "ticket_time": "2019-04-08 10:32:33",
//                 "money_in": "20.60",
//                 "money_out": "0.00",
//                 "numbers": "7,19",
//                 "numbers_won": "",
//                 "game_systems": "2\/2",
//                 "win_array": "0,329.6",
//                 "status": "Pierzator",
//                 "status_code": 22,
//                 "currency": "EUR"
//             },
//             {
//                 "ticketid": 227836475,
//                 "lottery_name": "Grecia Kino 20\/80",
//                 "round_id": 216136,
//                 "round_time": "2019-04-08 10:35:00",
//                 "ticket_time": "2019-04-08 10:32:33",
//                 "money_in": "20.60",
//                 "money_out": "0.00",
//                 "numbers": "7,19",
//                 "numbers_won": "",
//                 "game_systems": "2\/2",
//                 "win_array": "0,329.6",
//                 "status": "Pierzator",
//                 "status_code": 22,
//                 "currency": "EUR"
//             },
//             {
//                 "ticketid": 337836475,
//                 "lottery_name": "Grecia Kino 20\/80",
//                 "round_id": 216136,
//                 "round_time": "2019-04-08 10:35:00",
//                 "ticket_time": "2019-04-08 10:32:33",
//                 "money_in": "20.60",
//                 "money_out": "0.00",
//                 "numbers": "7,19",
//                 "numbers_won": "",
//                 "game_systems": "2\/2",
//                 "win_array": "0,329.6",
//                 "status": "Pierzator",
//                 "status_code": 22,
//                 "currency": "EUR"
//             },
//             {
//                 "ticketid": 447836475,
//                 "lottery_name": "Grecia Kino 20\/80",
//                 "round_id": 216136,
//                 "round_time": "2019-04-08 10:35:00",
//                 "ticket_time": "2019-04-08 10:32:33",
//                 "money_in": "20.60",
//                 "money_out": "0.00",
//                 "numbers": "7,19",
//                 "numbers_won": "",
//                 "game_systems": "2\/2",
//                 "win_array": "0,329.6",
//                 "status": "Pierzator",
//                 "status_code": 22,
//                 "currency": "EUR"
//             },
//             {
//                 "ticketid": 457836475,
//                 "lottery_name": "Grecia Kino 20\/80",
//                 "round_id": 216136,
//                 "round_time": "2019-04-08 10:35:00",
//                 "ticket_time": "2019-04-08 10:32:33",
//                 "money_in": "20.60",
//                 "money_out": "0.00",
//                 "numbers": "7,19",
//                 "numbers_won": "",
//                 "game_systems": "2\/2",
//                 "win_array": "0,329.6",
//                 "status": "Pierzator",
//                 "status_code": 22,
//                 "currency": "EUR"
//             },
//             {
//                 "ticketid": 567836475,
//                 "lottery_name": "Grecia Kino 20\/80",
//                 "round_id": 216136,
//                 "round_time": "2019-04-08 10:35:00",
//                 "ticket_time": "2019-04-08 10:32:33",
//                 "money_in": "20.60",
//                 "money_out": "0.00",
//                 "numbers": "7,19",
//                 "numbers_won": "",
//                 "game_systems": "2\/2",
//                 "win_array": "0,329.6",
//                 "status": "Pierzator",
//                 "status_code": 22,
//                 "currency": "EUR"
//             },
//             {
//                 "ticketid": 607836475,
//                 "lottery_name": "Grecia Kino 20\/80",
//                 "round_id": 216136,
//                 "round_time": "2019-04-08 10:35:00",
//                 "ticket_time": "2019-04-08 10:32:33",
//                 "money_in": "20.60",
//                 "money_out": "0.00",
//                 "numbers": "7,19",
//                 "numbers_won": "",
//                 "game_systems": "2\/2",
//                 "win_array": "0,329.6",
//                 "status": "Pierzator",
//                 "status_code": 22,
//                 "currency": "EUR"
//             },
//             {
//                 "ticketid": 667836475,
//                 "lottery_name": "Grecia Kino 20\/80",
//                 "round_id": 216136,
//                 "round_time": "2019-04-08 10:35:00",
//                 "ticket_time": "2019-04-08 10:32:33",
//                 "money_in": "20.60",
//                 "money_out": "0.00",
//                 "numbers": "7,19",
//                 "numbers_won": "",
//                 "game_systems": "2\/2",
//                 "win_array": "0,329.6",
//                 "status": "Pierzator",
//                 "status_code": 22,
//                 "currency": "EUR"
//             },
//             {
//                 "ticketid": 6667836475,
//                 "lottery_name": "Grecia Kino 20\/80",
//                 "round_id": 216136,
//                 "round_time": "2019-04-08 10:35:00",
//                 "ticket_time": "2019-04-08 10:32:33",
//                 "money_in": "20.60",
//                 "money_out": "0.00",
//                 "numbers": "7,19",
//                 "numbers_won": "",
//                 "game_systems": "2\/2",
//                 "win_array": "0,329.6",
//                 "status": "Pierzator",
//                 "status_code": 22,
//                 "currency": "EUR"
//             },
//         ]
//     }
// }
export default function (state = null, action) {
    if (action.type === 'ISTORIC_PARIURI') {
        state = action.payload;
    }
    return state;
}
